import { SolType } from '@sol/components';
import { AsmTableColumnWidthsTools } from '../tools/asm-table-column-widths.tools';
import { AsmTableColumnWidths } from '@asm/components-core/models/asm-setting';

export class AsmTableType {
  public static readonly tableColumnWidths = SolType.ofPrimitive<AsmTableColumnWidths | string>(
    'tableColumnWidths',
    () => ({}),
    AsmTableColumnWidthsTools.toText,
    AsmTableColumnWidthsTools.fromText,
  ).extend({ validators: [AsmTableColumnWidthsTools.validator] });
}
